import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { baseURL } from '../constants/base.url';
import { User } from '../models/auth.models';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<User | null>;
  public currentUser: Observable<User | null>;

  constructor(private http: HttpClient, private router: Router) {
    // Initialize the currentUserSubject from local storage
    this.currentUserSubject = new BehaviorSubject<User | null>(
      JSON.parse(localStorage.getItem('authenticatedUser') || 'null')
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User | null {
    return this.currentUserSubject.value;
  }

  // Login method
  login(credentials: { email: string; password: string }): Observable<any> {
    return this.http.post<any>(`${baseURL}auth/login`, credentials).pipe(
      map(response => {
        if (response && response.token) {
          // Store token and user data in localStorage
          localStorage.setItem('authToken', response.token);
          localStorage.setItem('authenticatedUser', JSON.stringify(response.user));

          // Update current user observable
          this.currentUserSubject.next(response.user);
        }
        return response;
      }),
      catchError(this.handleError)
    );
  }

  // Get token from localStorage
  getToken(): string | null {
    return localStorage.getItem('authToken');
  }

  // Set token and user data in localStorage
  setToken(token: string, user: any): void {
    localStorage.setItem('authToken', token);
    localStorage.setItem('authenticatedUser', JSON.stringify(user));
    this.currentUserSubject.next(user);
  }

  // Logout method
  logout(): void {
    localStorage.removeItem('authenticatedUser');
    localStorage.removeItem('authToken');
    this.currentUserSubject.next(null);
    this.router.navigate(['/account/login']);
  }

  // Check if the user is authenticated
  isAuthenticated(): boolean {
    const token = this.getToken();
    return !!token; // Returns true if token exists
  }


  // Handle errors during HTTP requests
  private handleError(error: any) {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${error.error.message}`;
    } else {
      errorMessage = `Server returned code: ${error.status}, error message is: ${error.message}`;
    }
    return throwError(errorMessage); // Use throwError instead of Observable.throw
  }
}
